import React from 'react';
import { Formik } from 'formik';
import { Grid, Step } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import BaseForm from './Base/Form';
import initialValues from './Base/initialValues';
import Validate from './Base/validation';
import onBaseSubmit from './Base/submit';

import CollaboratoreForm from './Collaboratore/Form';
import { collaboratoreInitialValues, mapToCollaboratoreInitialValues } from './Collaboratore/initialValues';
import onCollaboratoreSubmit from './Collaboratore/submit';

import ResponsabileareaForm from './ResponsabileArea/Form';
import { responsabileareaInitialValues, mapToResponsabileareaInitialValues } from './ResponsabileArea/initialValues';
import onResponsabileareaSubmit from './ResponsabileArea/submit';

import InternokironForm from './InternoKiron/Form';
import { internokironInitialValues, mapToInternokironInitialValues } from './InternoKiron/initialValues';
import onInternokironSubmit from './InternoKiron/submit';

import CoordinatoreForm from './Coordinatore/Form';
import { coordinatoreInitialValues, mapToCoordinatoreInitialValues } from './Coordinatore/initialValues';
import onCoordinatoreSubmit from './Coordinatore/submit';

import { clienteInitialValues } from './Cliente/initialValues';

import AnagraficaService from '../../../shared/services/api/anagrafica';
import CollaboratoreService from '../../../shared/services/api/collaboratore';
import ResponsabileareaService from '../../../shared/services/api/responsabilearea';
import InternokironService from '../../../shared/services/api/internokiron';
import CoordinatoreService from '../../../shared/services/api/coordinatore';

export class Anagrafica extends React.Component {

  constructor(props) {
    super(props);

    this.StepsTypes = {
      collaboratore: { key: 'Collaboratore', icon: 'id badge', title: 'Collaboratore', description: 'Dati collaboratore', link: true, onClick: () => this.nextStep() },
      responsabilearea: { key: 'Responsabile Area', icon: 'id badge', title: 'Responsabile Area', description: 'Dati responsabile area' },
      internokiron: { key: 'Interno Kiron', icon: 'id badge', title: 'Interno Kiron', description: 'Dati interno kiron' },
      coordinatore: { key: 'Coordinatore', icon: 'id badge', title: 'Coordinatore', description: 'Dati coordinatore' },
    };

    if (props.ruolo === 'Collaboratore') {
      this.BaseStep = [{ key: 'AnagraficaBase', active: true, icon: 'id card outline', title: 'Dati anagrafici', description: 'Dati anagrafici di base', link: true, onClick: () => this.prevStep() }];
    } else {
      this.BaseStep = [{ key: 'AnagraficaBase', active: true, icon: 'id card outline', title: 'Dati anagrafici', description: 'Dati anagrafici di base' }];
    }

    this.state = {
      loading: true,
      loadingAnagraficheRiconciliabili: false,
      anagraficheRiconciliabili: [],
      tipo: 'base',
      id: '',
      ruolo: props.ruolo,
      collaboratore: {},
      responsabilearea: {},
      internokiron: {},
      coordinatore: {},
      cliente: props.cliente,
      steps: this.StepsTypes[props.ruolo.toLowerCase().replace(' ', '')] ? this.BaseStep.concat([this.StepsTypes[props.ruolo.toLowerCase().replace(' ', '')]]) : this.BaseStep,
      currentTab: 'AnagraficaBase',
      saveOnly: false,
    };
  }

  componentWillMount() {
    if (this.props.initialValues && this.props.initialValues.id) {
      this.setState({ id: this.props.initialValues.id },
        () => {
          // Popolamento eventuali anagrafiche complementari (collaboratore, responsabile area etc)
          this.checkAdditionalData();
        }
      );
    } else {
      // Popolamento eventuali anagrafiche complementari (collaboratore, responsabile area etc)
      this.checkAdditionalData();
    }
  }

  componentDidMount() {
    this.setKeyListener();
  }

  componentWillUnmount() {
    this.removeKeyListener();
  }

  onKeyDown = (e) => { // CTRL + SHIFT + N (Skip to next step, shortcut for developers)
    if (e.ctrlKey && e.shiftKey) {
      if (e.keyCode === 78) this.nextStep();
    }
  }

  setKeyListener = () => {
    document.addEventListener('keydown', this.onKeyDown);
  }

  getRelated = (nominativo, recapiti, anagraficaId, codicefiscale) => {
    AnagraficaService.getByNominativoAndRecapiti(nominativo, recapiti, anagraficaId, codicefiscale).then((data) => {
      this.setState({ anagraficheRiconciliabili: data._embedded.anagrafica, id: anagraficaId, loadingAnagraficheRiconciliabili: false });
    });
  }

  setAnagraficaId = (id, cb) => this.setState({ id }, () => cb());

  getResponsabileAreaInitalValues = () => {
    const responsabileInitialValues = this.state.responsabilearea.id ? this.state.responsabilearea : responsabileareaInitialValues;
    const baseInitialValues = this.props.initialValues ? this.props.initialValues : initialValues;
    const baseResidenza = baseInitialValues.indirizzi ? _.orderBy(baseInitialValues.indirizzi.filter((value) => value.tipo === 'residenza'), ['createdAt'], ['asc'])[0] : {};
    if (
      responsabileInitialValues &&
      baseResidenza &&
      !responsabileInitialValues.indirizzoCompleto &&
      !responsabileInitialValues.comune &&
      !responsabileInitialValues.provincia &&
      !responsabileInitialValues.regione &&
      !responsabileInitialValues.cap &&
      !responsabileInitialValues.indirizzo
    ) {
      responsabileInitialValues.indirizzoCompleto = baseResidenza.indirizzoCompleto;
      responsabileInitialValues.comune = baseResidenza.comune;
      responsabileInitialValues.provincia = baseResidenza.provincia;
      responsabileInitialValues.regione = baseResidenza.comune;
      responsabileInitialValues.cap = baseResidenza.cap;
      responsabileInitialValues.indirizzo = baseResidenza.indirizzo;
    }
    return responsabileInitialValues;
  }

  getCollaboratoreInitalValues = () => {
    const localCollaboratoreInitialValues = this.state.collaboratore.id ? this.state.collaboratore : collaboratoreInitialValues;
    const baseInitialValues = this.props.initialValues ? this.props.initialValues : initialValues;
    const baseResidenza = baseInitialValues.indirizzi ? _.orderBy(baseInitialValues.indirizzi.filter((value) => value.tipo === 'residenza'), ['createdAt'], ['asc'])[0] : {};
    if (
      localCollaboratoreInitialValues &&
      baseResidenza &&
      !localCollaboratoreInitialValues.indirizzoCompleto &&
      !localCollaboratoreInitialValues.comune &&
      !localCollaboratoreInitialValues.provincia &&
      !localCollaboratoreInitialValues.regione &&
      !localCollaboratoreInitialValues.cap &&
      !localCollaboratoreInitialValues.indirizzo
    ) {
      localCollaboratoreInitialValues.indirizzoCompleto = baseResidenza.indirizzoCompleto;
      localCollaboratoreInitialValues.comune = baseResidenza.comune;
      localCollaboratoreInitialValues.provincia = baseResidenza.provincia;
      localCollaboratoreInitialValues.regione = baseResidenza.comune;
      localCollaboratoreInitialValues.cap = baseResidenza.cap;
      localCollaboratoreInitialValues.indirizzo = baseResidenza.indirizzo;
      localCollaboratoreInitialValues.numeroCivico = baseResidenza.numeroCivico;
      localCollaboratoreInitialValues.nazione = baseResidenza.nazione;
    }
    return localCollaboratoreInitialValues;
  }

  // NextStep, show next form and set wizard state to current active
  nextStep = () => { // eslint-disable-line
    if (this.state.saveOnly) {
      this.setState({ saveOnly: false });

      return false;
    }

    this.checkAdditionalData(
      () => {
        const steps = this.state.steps.concat([]);
        const newSteps = steps.map((step) => {
          const stepClone = Object.assign({}, step);
          stepClone.active = (step.key === this.props.ruolo);
          return stepClone;
        });
        this.setState({ currentTab: this.props.ruolo, steps: newSteps }, () => {
          const container = document.getElementById('scrollable');
          container.scrollTop = 0;
        });
      });
  };

  prevStep = () => {
    if (this.state.ruolo !== 'Collaboratore') {
      return;
    }

    const steps = this.StepsTypes[this.state.ruolo.toLowerCase().replace(' ', '')] ? this.BaseStep.concat([this.StepsTypes[this.state.ruolo.toLowerCase().replace(' ', '')]]) : this.BaseStep;

    this.setState({ currentTab: 'AnagraficaBase', steps }, () => {
      const container = document.getElementById('scrollable');
      container.scrollTop = 0;
    });
  }

  submit = (values, formikMethods, roleSubmit) => {
    const localData = {
      anagraficaId: this.state.id,
      onEdit: this.props.onEdit,
      update: this.props.update,
      submitRelated: this.submitRelated,
      notifications: this.props.notifications,
      setAnagraficaId: this.setAnagraficaId,
      nextStep: this.nextStep,
      tipoValidazione: this.props.validationType || this.state.ruolo,
      initialValues: _.isEmpty(this.props.initialValues) ? { ...initialValues, ...clienteInitialValues } : { ...this.props.initialValues, ...this.props.cliente },
    };

    let cleanValues = _.cloneDeep(values);
    cleanValues = _.omit(cleanValues, ['appointment']);

    if (!_.get(cleanValues, 'pignoramento')) {
      cleanValues.notePignoramento = '';
    }

    // needed to trigger user acl hydration on a new note in backend
    if (!_.isEmpty(cleanValues.note)) {
      cleanValues.note = cleanValues.note.map((nota) => nota.createdAt ? nota : _.omit(nota, ['id']));
    }

    roleSubmit(cleanValues, formikMethods, localData, this.props.addIntestatario);
  }

  setSaveOnly = (bol) => this.setState({ saveOnly: bol }, this.submitBase()) // true/false

  removeKeyListener = () => {
    document.removeEventListener('keydown', this.onKeyDown);
  }

   // Anagrafica base submit: usato per il submit in serie di 2 form.
  submitBase = () => {
    this.baseForm.submitForm();
  }

  // Anagrafica collaboratore submit: usato per il submit in serie di 2 form.
  submitRelated = () => {
    // if (this.state.ruolo === 'Collaboratore') this.collaboratoreForm.submitForm();
  }

  // Check display whether steps corresponds to form
  checkDisplay = (name) => ({ display: this.state.currentTab === name ? '' : 'none' });

  checkAdditionalData = (cb) => {
    // If form role is "Collaboratore" and a Collaboratore is actually defined, load Collaboratore form state
    if (this.state.ruolo === 'Collaboratore' && this.props.initialValues && this.props.initialValues.dettaglioCollaboratore) {
      CollaboratoreService.getWithProfiliAndContratti(this.props.initialValues.dettaglioCollaboratore).then(
        (data) => this.setState({
          loading: false,
          collaboratore: mapToCollaboratoreInitialValues(data),
        }, cb ? cb() : null)
      );
    } else if (this.state.ruolo === 'Responsabile Area' && this.props.initialValues && this.props.initialValues.dettaglioResponsabileArea) {
      ResponsabileareaService.getById(this.props.initialValues.dettaglioResponsabileArea).then(
        (data) => this.setState({
          loading: false,
          responsabilearea: mapToResponsabileareaInitialValues(data),
        }, cb ? cb() : null)
      );
    } else if (this.state.ruolo === 'Interno Kiron' && this.props.initialValues && this.props.initialValues.dettaglioInternoKiron) {
      InternokironService.getById(this.props.initialValues.dettaglioInternoKiron).then(
         (data) => this.setState({
           loading: false,
           internokiron: mapToInternokironInitialValues(data),
         }, cb ? cb() : null)
      );
    } else if (this.state.ruolo === 'Coordinatore' && this.props.initialValues && this.props.initialValues.dettaglioCoordinatore) {
      CoordinatoreService.getById(this.props.initialValues.dettaglioCoordinatore.id).then(
        (data) => this.setState({
          loading: false,
          coordinatore: mapToCoordinatoreInitialValues(data),
        }, cb ? cb() : null)
      );
    } /* else {
      this.setState({
        loading: false,
        collaboratore: collaboratoreInitialValues,
      });
    }*/
  }

  initRelated = () => {
    if (!this.props.initialValues) {
      return;
    }

    const { nominativo, id, recapiti, codicefiscale } = this.props.initialValues;

    if (id) {
      this.setState({ loadingAnagraficheRiconciliabili: true });

      this.getRelated(nominativo, recapiti, id, codicefiscale);
    }
  }

  reconciliate = (destinationId) => {
    this.props.reconcile(this.state.id, destinationId);
  }

  render() {
    return (<Grid className="anagraficaContainer">
      { /* Anagrafica Base */ }
      <Grid.Column width={16} style={{ padding: 0, width: '100%' }}>
        <Step.Group fluid items={this.state.steps} />
      </Grid.Column>
      <Grid.Column width={16} style={this.checkDisplay('AnagraficaBase')}>
        <Formik
          ref={(c) => { this.baseForm = c; }}
          initialValues={{
            ...initialValues,
            ...clienteInitialValues,
            ...(this.props.initialValues || {}),
            ...(this.state.cliente || {}),
          }}
          validate={Validate}
          onSubmit={(values, formikMethods) => this.submit(values, formikMethods, onBaseSubmit)}
          render={(props) => (<BaseForm
            onSaveOnly={this.setSaveOnly}
            closeModal={this.props.close}
            {...props}
            isEdit={!!_.get(this.props.initialValues, 'id')}
            ruolo={this.state.ruolo}
            cliente={this.state.cliente ? this.state.cliente : clienteInitialValues}
            reconciliate={this.reconciliate}
            getAnagraficheRiconciliabili={this.initRelated}
            loadingAnagraficheRiconciliabili={this.state.loadingAnagraficheRiconciliabili}
            anagraficheRiconciliabili={this.state.anagraficheRiconciliabili}
            validationType={this.props.validationType}
            auth={this.props.auth}
            notification={this.props.notifications}
            update={this.props.update}
          />)}
        />
      </Grid.Column>
      { /* Anagrafica collaboratore */}
      {this.state.ruolo === 'Collaboratore' && !this.state.loading &&
        <Grid.Column width={16} style={this.checkDisplay('Collaboratore')}>
          <Formik
            ref={(c) => { this.collaboratoreForm = c; }}
            initialValues={this.getCollaboratoreInitalValues()}
            validate={Validate}
            onSubmit={(values, formikMethods) => this.submit(values, formikMethods, onCollaboratoreSubmit)}
            render={(props) => (<CollaboratoreForm closeModal={this.props.close} notifications={this.props.notifications} auth={this.props.auth} {...props} />)}
          />
        </Grid.Column>
      }
      { /* Anagrafica responsabile area */}
      {this.state.ruolo === 'Responsabile Area' && !this.state.loading &&
      <Grid.Column width={16} style={this.checkDisplay('Responsabile Area')}>
        <Formik
          ref={(c) => { this.responsabileareaForm = c; }}
          initialValues={this.getResponsabileAreaInitalValues()}
          validate={Validate}
          onSubmit={(values, formikMethods) => this.submit(values, formikMethods, onResponsabileareaSubmit)}
          render={(props) => (<ResponsabileareaForm closeModal={this.props.close} {...props} />)}
        />
      </Grid.Column>
      }
      { /* Anagrafica coordinatore */}
      {this.state.ruolo === 'Coordinatore' && !this.state.loading &&
      <Grid.Column width={16} style={this.checkDisplay('Coordinatore')}>
        <Formik
          ref={(c) => { this.coordinatoreForm = c; }}
          initialValues={this.state.coordinatore.id ? this.state.coordinatore : coordinatoreInitialValues}
          validate={Validate}
          onSubmit={(values, formikMethods) => this.submit(values, formikMethods, onCoordinatoreSubmit)}
          render={(props) => (<CoordinatoreForm closeModal={this.props.close} {...props} />)}
        />
      </Grid.Column>
      }
      {this.state.ruolo === 'Interno Kiron' && !this.state.loading &&
      <Grid.Column width={16} style={this.checkDisplay('Interno Kiron')}>
        <Formik
          ref={(c) => { this.clienteForm = c; }}
          initialValues={this.state.internokiron.id ? this.state.internokiron : internokironInitialValues}
          validate={Validate}
          onSubmit={(values, formikMethods) => this.submit(values, formikMethods, onInternokironSubmit)}
          render={(props) => (<InternokironForm closeModal={this.props.close} {...props} />)}
        />
      </Grid.Column>
      }
    </Grid>);
  }
}

Anagrafica.propTypes = {
  initialValues: PropTypes.object,
  cliente: PropTypes.object,
  reconcile: PropTypes.func,
  notifications: PropTypes.object,
  update: PropTypes.func,
  onEdit: PropTypes.func,
  ruolo: PropTypes.string,
  close: PropTypes.func,
  addIntestatario: PropTypes.func,
  validationType: PropTypes.string,
  auth: PropTypes.object,
};

export default Anagrafica;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/index.js